import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React, {type FC, useCallback} from 'react';

import {DD_PRIVACY_ALLOW} from '../../../../util/datadog/privacy';

interface ColorActionsMenuProps {
  trackInvertColors?: () => void;
  trackResetColors?: () => void;
  onInvertColors: () => void;
  onResetColors: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
}

export const ColorActionsMenu: FC<ColorActionsMenuProps> = ({
  setIsOpen,
  isOpen,
  trackInvertColors,
  trackResetColors,
  onInvertColors,
  onResetColors,
}) => {
  const invertColors = useCallback(() => {
    trackInvertColors?.();
    onInvertColors();
    setIsOpen(false);
  }, [onInvertColors, setIsOpen, trackInvertColors]);

  const resetColors = useCallback(() => {
    trackResetColors?.();
    onResetColors();
    setIsOpen(false);
  }, [onResetColors, setIsOpen, trackResetColors]);

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <Button
          active={isOpen}
          data-test="buckets-actions-overflow"
          icon="overflow-horizontal"
          variant="ghost"
          aria-label="More actions"
          size={'small'}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="center">
          <DropdownMenu.Item
            data-dd-action-name="Invert colors"
            data-dd-privacy={DD_PRIVACY_ALLOW}
            data-test="invert-colors-button"
            onClick={invertColors}>
            <Icon name="swap" /> Invert colors
          </DropdownMenu.Item>
          <DropdownMenu.Item
            data-dd-action-name="Reset colors"
            data-dd-privacy={DD_PRIVACY_ALLOW}
            data-test="reset-colors-button"
            onClick={resetColors}>
            <Icon name="reload-refresh" /> Reset colors
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
